import { CurrencyCode } from '@99designs/i18n';

interface StepSpec {
    max: number;
    step: number;
}

const STEPS_CURRENCY: { [currency in CurrencyCode]: StepSpec[] } = {
    [CurrencyCode.AUD]: [
        { max: 500, step: 20 },
        { max: 1000, step: 50 },
        { max: 2000, step: 100 },
        { max: 5000, step: 300 },
    ],
    [CurrencyCode.CAD]: [
        { max: 500, step: 20 },
        { max: 1000, step: 50 },
        { max: 2000, step: 100 },
        { max: 5000, step: 300 },
    ],
    [CurrencyCode.CHF]: [
        { max: 500, step: 20 },
        { max: 1000, step: 50 },
        { max: 2000, step: 100 },
        { max: 5000, step: 300 },
    ],
    [CurrencyCode.DKK]: [
        { max: 3000, step: 100 },
        { max: 6000, step: 250 },
        { max: 12000, step: 500 },
        { max: 30000, step: 2000 },
    ],
    [CurrencyCode.EUR]: [
        { max: 400, step: 20 },
        { max: 800, step: 50 },
        { max: 1600, step: 100 },
        { max: 4000, step: 300 },
    ],
    [CurrencyCode.GBP]: [
        { max: 350, step: 25 },
        { max: 700, step: 50 },
        { max: 1400, step: 100 },
        { max: 3500, step: 300 },
    ],
    [CurrencyCode.HKD]: [
        { max: 4000, step: 150 },
        { max: 8000, step: 500 },
        { max: 16000, step: 800 },
        { max: 40000, step: 2400 },
    ],
    [CurrencyCode.JPY]: [
        { max: 5000, step: 200 },
        { max: 10000, step: 500 },
        { max: 20000, step: 1000 },
        { max: 50000, step: 3000 },
    ],
    [CurrencyCode.MXN]: [
        { max: 10000, step: 400 },
        { max: 20000, step: 1000 },
        { max: 40000, step: 2000 },
        { max: 100000, step: 6000 },
    ],
    [CurrencyCode.NOK]: [
        { max: 4000, step: 150 },
        { max: 8000, step: 500 },
        { max: 16000, step: 800 },
        { max: 40000, step: 2400 },
    ],
    [CurrencyCode.SGD]: [
        { max: 500, step: 20 },
        { max: 1000, step: 50 },
        { max: 2000, step: 100 },
        { max: 5000, step: 300 },
    ],
    [CurrencyCode.USD]: [
        { max: 500, step: 20 },
        { max: 1000, step: 50 },
        { max: 2000, step: 100 },
        { max: 5000, step: 300 },
    ],
};

export const generateStepMapping = (steps: StepSpec[]): number[] => {
    const stepMapping: number[] = [];
    let currentMax = 0;
    // eslint-disable-next-line array-callback-return
    steps.map(({ max, step }) => {
        for (let i = currentMax; i < max; i += step) {
            stepMapping.push(i);
        }
        currentMax = max;
    });
    stepMapping.push(currentMax);
    return stepMapping;
};

const getBudgetStepsForCurrency = (currency: CurrencyCode): number[] =>
    generateStepMapping(STEPS_CURRENCY[currency]);
export default getBudgetStepsForCurrency;
